<template>
  <div>
    <div
      v-if="!$isDingDing"
      class="row"
    >
      <div class="row-label">
        {{ $t('message["720"]') }}：
      </div>
      <div class="row-cell">
        <template v-if="user.bind_qiwei *1 === 0">
          <a
            :href="user.qwBindUrl"
          > {{ $t('message["900"]') }}</a>
          <span
            class="company-name ml-16"
          > {{ $t('message["16"]') }}</span>
        </template>
        <template v-else>
          <template v-if="user.bindQiweiInfo && user.bindQiweiInfo.length">
            <div class="user-list">
              <div
                v-for="item in user.bindQiweiInfo "
                :key="item.id"
                class="user-item"
              >
                <div class="account-tit-name">
                  <span
                    v-if="$store.state.qwWork === 'isWxWork'"
                    class="iframe-qw-name"
                  >{{ item.bind_info.userid }}</span>
                  <iframe
                    v-else
                    class="iframe-qw-name"
                    :src="item.iframeUrl"
                    scrolling="no"
                  />
                </div>
                <span
                  v-if="item.bind_info.corp_full_name"
                  class="company-name mr-16"
                >
                  {{ item.bind_info.corp_full_name }}
                </span>
                <un-bind
                  :id="item.bind_id"
                  :title="qwTitTxt"
                  :name="item.bind_info.name"
                  :comname="item.bind_info.corp_full_name"
                  bind-id="bind_qiwei"
                  :is-can-unbind="user.is_can_unbind === 1"
                />
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
    <div
      v-if="!$isDingDing"
      class="row"
    >
      <div class="row-label">
        {{ $t('message["391"]') }}：
      </div>
      <div class="row-cell">
        <template v-if="user.bind_gcw *1 === 0">
          <a
            :href="user.gcwBindUrl"
            target="_blank"
          > {{ $t('message["900"]') }}</a>
          <span class="company-name ml-16">{{ $t('message["15"]') }}</span>
        </template>
        <template v-else>
          <template v-if="user.bindGcwInfo">
            <div class="user-list">
              <div class="user-item">
                <div class="account-tit-name">
                  <span>{{ user.bindGcwInfo.bind_info.name }}</span>
                </div>
                <span
                  v-if="user.bindGcwInfo.bind_info.comname"
                  class="company-name mr-16"
                >
                  {{ user.bindGcwInfo.bind_info.comname }}
                </span>
                <un-bind
                  :id="user.bindGcwInfo.bind_id"
                  :title="gcTitTxt"
                  :name="user.bindGcwInfo.bind_info.name"
                  :comname="user.bindGcwInfo.bind_info.comname"
                  :is-can-unbind="user.is_can_unbind === 1"
                  bind-id="bind_gcw"
                />
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
    <div
      v-if="!$isDingDing"
      class="row"
    >
      <div class="row-label">
        {{ $t('message["1254"]') }}：
      </div>
      <div class="row-cell">
        <template v-if="user.bind_wechat *1 === 0">
          <a
            href="javascript:;"
            @click="QrcodeHandler"
          > {{ $t('message["900"]') }}</a>
          <span
            class="company-name ml-16"
          > {{ $t('message["17"]') }}</span>
          <qrcode-dialog
            ref="qrcodedialog"
            :url="user.wechatBindUrl"
          />
        </template>
        <template v-else>
          <template v-if="user.bindWechat">
            <span class="mr-16">{{ user.bindWechat.bind_info.nickname }}</span>
            <!-- <span class="ml-16">
              {{ user.bindQiweiInfo.bind_info.corp_full_name }}
            </span> -->
            <un-bind
              :id="user.bindWechat.bind_id"
              :title="wxTit"
              :name="user.bindWechat.bind_info.nickname"
              bind-id="bind_wechart"
              :is-can-unbind="user.is_can_unbind === 1"
            />
          </template>
        </template>
      </div>
    </div>
    <div
      v-if="user.bind_dingding *1 === 1"
      class="row"
    >
      <div class="row-label">
        {{ dingdingAccoutTit }}：
      </div>
      <div class="row-cell">
        <template v-if="user.bindDingdingInfo && user.bindDingdingInfo.length > 0">
          <div class="user-list">
            <div
              v-for="item in user.bindDingdingInfo "
              :key="item.id"
              class="user-item"
            >
              <div class="account-tit-name">
                <span>{{ item.bind_info.name }}</span>
              </div>
              <span
                v-if="item.bind_info.corp_full_name "
                class="company-name mr-16 "
              >
                {{ item.bind_info.corp_full_name }}
              </span>
              <un-bind
                :id="item.bind_id"
                :title="dingdingAccoutTit"
                :name="item.bind_info.name"
                :comname="item.bind_info.corp_full_name"
                bind-id="bind_dingding"
                :is-can-unbind="user.is_can_unbind === 1"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import UnBind from './UnBind'
import { mapState } from 'vuex'
import QrcodeDialog from '@/components/pc/account/QrcodeDialog'
export default {
  components: {
    UnBind,
    QrcodeDialog
  },
  computed: {
    ...mapState('account/accountInfo', ['accountDetail']),
    user () {
      const { accountDetail = {} } = this
      const { group = {} } = accountDetail
      const groups = []
      for (let i in group) {
        groups.push(group[i])
      }
      accountDetail.groups = groups.join(' ')
      return accountDetail
    },
    dingdingAccoutTit () {
      return this.$t('message["242"]')
    },
    gcTitTxt () {
      return this.$t('message["391"]')
    },
    qwTitTxt () {
      return this.$t('message["720"]')
    },
    wxTit () {
      return this.$t('message["1254"]')
    }
  },
  methods: {
    QrcodeHandler () {
      this.$refs.qrcodedialog.changeLimitDialog(true)
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-list::v-deep {
    margin-bottom: -4px;
    margin-top: -6px;
    .user-item {
      padding-top: 4px;
      line-height: 24px;
      padding-bottom: 12px;
      box-sizing: content-box;
      .iframe-qw-name {
        display: inline;
        height: 24px;
        vertical-align: middle;
        width: 400px;
        border: 0;
      }
      .account-tit-name {
        padding-bottom: 8px;
      }
    }
  }
</style>
